module.exports = __webpack_public_path__ + "img/fenxi-2.0add641d.png";